var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92023 0.868682C10.0303 0.679842 10.1879 0.523156 10.3774 0.414256C10.5669 0.305355 10.7817 0.248047 11.0002 0.248047C11.2188 0.248047 11.4335 0.305355 11.623 0.414256C11.8125 0.523156 11.9702 0.679842 12.0802 0.868682L14.8752 5.66668L20.3032 6.84268C20.5167 6.88908 20.7144 6.99063 20.8764 7.13721C21.0384 7.2838 21.1592 7.47029 21.2267 7.67811C21.2942 7.88592 21.306 8.10779 21.261 8.3216C21.216 8.53541 21.1157 8.7337 20.9702 8.89668L17.2702 13.0377L17.8302 18.5627C17.8523 18.7802 17.817 18.9998 17.7277 19.1994C17.6384 19.399 17.4983 19.5717 17.3214 19.7002C17.1444 19.8288 16.9369 19.9086 16.7195 19.9319C16.502 19.9551 16.2823 19.9209 16.0822 19.8327L11.0002 17.5927L5.91823 19.8327C5.71815 19.9209 5.49842 19.9551 5.28098 19.9319C5.06355 19.9086 4.85601 19.8288 4.6791 19.7002C4.50219 19.5717 4.36209 19.399 4.2728 19.1994C4.1835 18.9998 4.14814 18.7802 4.17023 18.5627L4.73023 13.0377L1.03023 8.89768C0.884457 8.73471 0.783985 8.53635 0.738843 8.3224C0.693701 8.10846 0.70547 7.88641 0.772973 7.67844C0.840476 7.47046 0.961353 7.28383 1.12354 7.13718C1.28572 6.99053 1.48353 6.88898 1.69723 6.84268L7.12523 5.66668L9.92023 0.868682Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarWhite);
export default __webpack_public_path__ + "static/media/Ic_Star_white.9747a0915847720a969a66d92549b243.svg";
export { ForwardRef as ReactComponent };